import { createTemplateSignatoriesService } from "../../../actions/DocumentTemplateActions/templateService";
import { getFormFieldsDiffList } from "../../../utils/editorUtils";
import DeleteBaseCommand from "./deleteBaseCommand";

class DeletePDFTemplateCommand extends DeleteBaseCommand {
  constructor(componentData) {
    super(componentData);
    this.componentData = componentData;
  }

  execute() {
    const { section, mode, sectionID } = this.componentData;
    this.updatedSection = section;
    if (section) {
      this.updatedSection.fieldDiffList = getFormFieldsDiffList(section, null);
    }

    this.componentData.deleteDocumentComponentAction(
      sectionID,
      this.updatedSection,
    );
    const data = this.componentData.signerData.find(
      item => item.component_id === sectionID,
    );
    const deleteSigner = [
      {
        component_id: data.component_id,
        ids: [data.signers[0].id],
      },
    ];
    // Only 1 component for PDF - signature component
    this.componentData.deleteDocSignerSection(
      mode,
      deleteSigner,
      this.componentData.docID,
    );
  }

  undo() {
    super.undo();
    const { docID, section } = this.componentData;
    const signatureData = [
      {
        component_id: section.id,
        signers: section.data,
      },
    ];
    createTemplateSignatoriesService(docID, signatureData);
  }
}

export default DeletePDFTemplateCommand;
